import { ChangeEvent, ReactNode, useCallback } from "react";

import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { EnumHelper } from "@/Common/Helpers/EnumHelper";
import { ServicePublishingRule } from "@/Common/Models/Services/IServicePublishingConfig";

import "./ServiceDelaySelect.scss";

interface ServiceDelaySelectProps {
    hint?: string | null;
    label?: ReactNode;
    value?: number;
    onChange?: (value: number) => void;
}

function ServiceDelaySelect(props: ServiceDelaySelectProps): JSX.Element {
    const { hint, value = ServicePublishingRule.Immediate, onChange } = props;

    const { getText } = useTranslation();

    const handleChange = useCallback(
        (e: ChangeEvent<HTMLSelectElement>) => {
            const type = !isNaN(parseInt(e.target.value)) ? +e.target.value : null;

            onChange?.(type as ServicePublishingRule);
        },
        [onChange]
    );

    return (
        <div className="form-group">
            <select
                className="form-control"
                value={value ?? ""}
                onChange={handleChange}
            >
                {EnumHelper.getNamesAndValues(ServicePublishingRule)
                    .map(pair => {
                        const label = getText(`AvailabilityTimeRule_${pair.name}_PublicationLabel`);

                        return (
                            <option key={pair.name} value={pair.value}>{label}</option>
                        );
                    })}
            </select>

            <span className="help-block">{hint}</span>
        </div>
    );
}

export { ServiceDelaySelect };
